export default __webpack_public_path__ + "static/media/board.c5da929a.svg";